/**
 * 
 * @param cookies 
 * @returns 
 */
export const getSoleAuth = (cookies) => {
  return cookies.get('SoleAuth')
}

export const getUserIsLogged = (cookies) => {
  return !!getSoleAuth(cookies);
}

const getFieldFromQs = (qs, field) => {
  try {
    return qs.split("&").find(item => item.includes("fullname")).split("=")[1];
  } catch (er) {
    console.error( `GetFieldFromQs : field ${field} not found in ${qs}` )
  }
}

export const getShortName = (cookies) => {
  const SoleUser = cookies.get('SoleUser');
  if (SoleUser) {
    return getFieldFromQs(SoleUser, 'shortname')
  }
}
export const getFullName = (cookies) => {
  const SoleUser = cookies.get('SoleUser');
  if (SoleUser) {
    return getFieldFromQs(SoleUser, 'fullname')
  }
}